<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <!--      <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>-->
          <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
          <el-button size="mini" type="primary" @click="search">搜索</el-button>
        </div>

        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
            <el-table-column prop="id" label="id" align="center"></el-table-column>
            <el-table-column prop="contract_name" label="合同名称" align="center"></el-table-column>
            <el-table-column prop="contract_cycle" label="收费项" align="center"></el-table-column>
            <el-table-column prop="cycle_amount" label="费项金额" align="center"></el-table-column>
            <el-table-column prop="invoice_amount" label="发票金额" align="center"></el-table-column>
            <el-table-column prop="paid_amount" label="实缴金额" align="center"></el-table-column>
            <el-table-column prop="invoice_time" label="开发票时间" align="center"></el-table-column>
            <el-table-column prop="paid_time" label="实缴时间" align="center"></el-table-column>

            <el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
            <el-table-column prop="update_time" label="修改时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="180">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
                <!--            <el-button type="primary" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">删除</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="项目编辑" :visible.sync="dialogVisible" width="600px">

      <div style="max-height: 600px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="合同名称" prop="title">
            <el-input class="form-input" v-model="form.contract_name" disabled autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收费项" prop="title">
            <el-input class="form-input" v-model="form.contract_cycle" disabled autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="费项金额" prop="title">
            <el-input class="form-input" v-model="form.cycle_amount" disabled autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="发票金额" prop="title">
            <el-input class="form-input" v-model="form.invoice_amount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开发票时间" prop="title">
            <el-date-picker
              v-model="form.invoice_time"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="实缴金额" prop="title">
            <el-input class="form-input" v-model="form.paid_amount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="实缴时间" prop="title">
            <el-date-picker
              v-model="form.paid_time"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="附件" prop="title">
            <upload-files-sysc v-model="form.files"></upload-files-sysc>
          </el-form-item>

          <el-form-item label="备注" prop="title">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import { Loading } from 'element-ui';
import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";

export default {
  name:"ContractFinancialManagement",
  components: {AreaTree, UploadFilesSysc},
  data () {
    return {
      keyword: '',
      loading: false,
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      pageChannelData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        contract_name:"",
        contract_cycle:"",
        cycle_amount:"",
        invoice_amount:"",
        invoice_time:"",
        paid_amount:"",
        paid_time:"",
        files:"",
        remarks:"",
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[]
    }
  },
  created() {
    this.uploadUrl=this.$myhttp.defaults.baseURL+"/admin/OAIndex/uploadFile"
    this.getChannelList()
    this.getList()
    console.log(this.uploadUrl)
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        contract_name:"",
        contract_cycle:"",
        cycle_amount:"",
        invoice_amount:"",
        invoice_time:"",
        paid_amount:"",
        paid_time:"",
        files:"",
        remarks:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      ERP.getRequest({
        url:"admin/OAIndex/getApplicationList",
        data:{keyword: this.keyword, page: this.pageData.page, page_size: this.pageData.pageSize}
      }, res => {
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    getChannelList(){
      var that=this;
      that.loading=true;
      ERP.getRequest({
        url:"admin/OAIndex/getApplicationChannelList",
        data:{keyword: this.keyword, page: this.pageData.page, page_size: this.pageData.pageSize}
      }, res => {
        if(res.code) {
          that.pageChannelData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {

      if(!item) {
        this.form = this.getFormData({})
      } else {
        this.form = item
      }
      this.dialogVisible = true
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          console.log(data)
          // ERP.postRequest({
          //   url:"admin/OAIndex/setApplication",
          //   data:data
          // }, res => {
          //   this.$message({type: res.code == 1 ? 'success': 'error', message: res.msg})
          //   if(res.code) {
          //     this.dialogVisible = false
          //     this.getList()
          //   }
          //   this.formLoading = false
          // })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      // ERP.postRequest({
      //   url:"admin/OAIndex/setApplication",
      //   data:data
      // }, res => {
      //   that.$message({type: res.code == 1 ? 'success': 'error', message: res.msg})
      //   if(res.code) {
      //     that.getList()
      //   }
      // })
    },

    componentMonth(){
      var that=this;
      if(that.form.charging_start_end_time){
        let list=CommonHelp.getMonths(that.form.charging_start_time,that.form.charging_end_time);
        let m_list=JSON.parse(JSON.stringify(that.month_money_list))
        that.month_money_list=[];
        let month_money=Math.round(that.form.contract_price/list.length*100)/100
        list.map((ret,index)=>{
          that.month_money_list.push({
            ...m_list[index],
            month:ret,
            money:month_money
          })
        })
      }else {
        that.month_money_list=[]
      }
      that.$forceUpdate()
      console.log(that.month_money_list)
    },

    setMoney(item,index){
      var that=this;
      let month_money=Math.round(that.form.contract_price/that.month_money_list.length*2*100)/100
      if(index){
        that.month_money_list[0].money=Math.round((month_money-item.money)*100)/100
      }else {
        that.month_money_list[that.month_money_list.length-1].money=Math.round((month_money-item.money)*100)/100
      }
    },

    addProject(){
      this.project_list.push({
        name:"",
        square_measure:"",
        unit_price:""
      })
    },
    deleteProject(item,index){
      this.project_list.splice(index,1)
    },

    UploadFileFJSuccess(list){
      console.log(list)
      this.form.image=list;
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ContractFinancialManagement.vue